import StepIcon from '../../components/StepIcon';
var MuiStepLabel = {
    StepIconComponent: StepIcon,
};
export default MuiStepLabel;
//# sourceMappingURL=MuiStepLabel.js.map